import { deleteCall, get, post, put } from '.';

export const addAttendees = (eventId: string | number, attendees: Array<{ email: string }>) =>
    post(`events/${eventId}/attendees/batch`, { attendees }).then(json => json.attendees) as Promise<
        Bizly.EventAttendee[]
    >;

export type AttendeeImportPayload = {
    email: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    hotelConfirmationNumber?: string;
    externalId?: string;
};

export type AttendeeImportSummary = {
    added: number;
    updated: number;
    skipped: number;
    skippedEmails: string[];
};

export type AttendeeImportResult = {
    attendees: Bizly.EventAttendee[];
    importSummary?: AttendeeImportSummary;
};

export const importAttendees = (
    eventId: string | number,
    attendees: AttendeeImportPayload[],
    updateOnly: boolean
): Promise<AttendeeImportResult> =>
    post(`events/${eventId}/attendees/batch`, { attendees, updateOnly }).then(json => ({
        attendees: json.attendees as Bizly.EventAttendee[],
        importSummary: json.importSummary as AttendeeImportSummary | undefined,
    }));

export const loadAttendees = (eventId: number | string) =>
    get(`events/${eventId}/attendees`) as Promise<BizlyAPI.EventAttendees>;

export const removeAttendee = (eventId: number, attendee: BizlyAPI.Attendee) =>
    deleteCall(`events/${eventId}/attendees/${attendee.id}`);

export const bulkRemoveAttendees = (eventId: number | string, attendeeIds: number[]) =>
    deleteCall(`events/${eventId}/attendees`, { attendees: attendeeIds }) as Promise<{ success: boolean }>;

export const updateAttendee = (eventId: number, attendee: Bizly.EventAttendee) =>
    put(`events/${eventId}/attendees/${attendee.id}`, attendee);

export const quickInviteAttendee = (meetingId: string | number, email: string) =>
    post(`meetings/${meetingId}/send-invite`, { email }) as Promise<{ meeting: BizlyAPI.Meeting }>;

export const acceptInvite = (meetingId: string | number) =>
    post(`meetings/${meetingId}/accept-invite`) as Promise<{ meeting: BizlyAPI.Meeting }>;

export const rejectInvite = (meetingId: string | number) =>
    post(`meetings/${meetingId}/reject-invite`) as Promise<{ meeting: BizlyAPI.Meeting }>;

export const sendNoteToAttendees = (eventId: number | string, data: BizlyAPI.AttendeeNote) =>
    post(`events/${eventId}/attendees/send-note`, data) as Promise<{ message: string; success: boolean }>;
